<div class="title">Analytics Content</div>
<!-- <div class="information">
</div> -->
<table >
  <Thead>
    <th>
      Mail Sent
    </th>
    <th>
      Mail Viewed
    </th>
  </Thead>
  <tbody>
    <tr>
      <td>
        {{(this.analytics.mailSent ? ("Yes, " + this.formatDate(this.analytics.mailSentAt)) : "No")}}

      </td>
      
      <td>
        {{(this.analytics.mailViewed ? ("Yes, " + this.formatDate(this.analytics.mailViewedAt)) : "No")}}
      </td>
    </tr>
  </tbody>
</table>



